import type React from 'react';
import type { IconProps } from 'types/icon';

const CheckCircleAnimated: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeDasharray="62.83"
        strokeDashoffset="62.83"
        transform="rotate(-90 12 12)"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="62.83"
          to="0"
          dur="0.45s"
          fill="freeze"
        />
      </circle>
      <path
        d="M8.5 12.5L10.5 14.5L15.5 9.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="10"
        strokeDashoffset="10"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="10"
          to="0"
          dur="0.3s"
          begin="0.4s"
          fill="freeze"
        />
      </path>
    </svg>
  );
};

export default CheckCircleAnimated;
